import React from 'react';
import { findDOMNode } from 'react-dom';
import moment from 'moment-timezone';
import _ from 'lodash';
import ToolTip from 'react-tooltip';
import shortid from 'shortid';
const { URL_PREFIX } = window;

const FlightSegmentView = (props) => {
    let ref = null;
    const departure = props.flightData.find(obj => obj.RecordType && obj.RecordType.Name === 'OUT-Flight' && obj.Flight_Type__c !== 'Alternative' &&
        moment(obj.Departure_Date_Time__c).tz('Asia/Makassar').format('YYYY-MM-DD') === props.printedDate);
    const arrival = props.flightData.find(obj => obj.RecordType && obj.RecordType.Name === 'IN-Flight' && obj.Flight_Type__c !== 'Alternative' &&
        moment(obj.Departure_Date_Time__c).tz('Asia/Makassar').format('YYYY-MM-DD') === props.printedDate);
    const flightInfo = { in: arrival ? arrival.Id : shortid.generate(), out: departure ? departure.Id : shortid.generate() };
    const element = (
        <div style={{ position: 'relative', overflow: 'visible' }}>
            <span
                className="label label-default"
                style={{ position:'relative', marginRight: 5, backgroundColor: props.colorList[arrival !== undefined ? arrival.Availability__c : 'none'] }}
            >
                I
                {arrival && arrival.Availability__c === 'Full' &&
                    <span style={{ position: 'absolute', top: '-12px', left: '50%', transform: 'translateX(-50%)', color: props.colorList['Full'], fontWeight: 'bold', fontSize:'12px' }}>F</span>

                }
            </span>
            <a
                href={null}
                data-for={`${flightInfo.in}${flightInfo.out}`}
                data-event="click"
                data-tip={JSON.stringify({ printedDate: props.printedDate, flightInfo })}
                className="btn btn-xs btn-default"
                style={{ backgroundColor: '#eee', color: '#444', border: (arrival?.Holiday_Season__c || departure?.Holiday_Season__c) ? '3px solid #03fc45' : 'none' }}
                value={props.printedDate}
                ref={(c) => { ref = c; }}
                onClick={(e) => {
                    e.preventDefault();
                }}

            >
                {moment(props.printedDate).format('ddd')}
                <br />
                {moment(props.printedDate).format('DD/MM')}
            </a>
            <ToolTip
                id={`${flightInfo.in}${flightInfo.out}`}
                effect="solid"
                place="bottom"
                border={false}
                type="dark"
                className="tooltipHover"
                globalEventOff="click"
                clickable
                isCapture="true"
                getContent={data => (
                    <div className="tooltip-container btn-group" role="group">
                        <button
                            type="button"
                            onClick={(e) => {
                                const newData = JSON.parse(data);
                                props.changeFlightModal(true, newData.flightInfo);
                                ToolTip.hide(findDOMNode(ref));
                            }}
                            className="btn btn-primary"
                        >
                            <i className="fa fa-plane" /> Flight Info
                        </button>
                        <button
                            type="button"
                            onClick={() => {
                                const newData = JSON.parse(data);
                                ToolTip.hide(findDOMNode(ref));
                                props.history.push(`${URL_PREFIX}/app/guest-list/${newData.printedDate}`);
                            }}
                            className="btn btn-info"
                        >
                            <i className="fa fa-users" /> Guests
                        </button>
                    </div>
                )}
            />
            <span
                className="label label-default"
                style={{ position:'relative', marginLeft: 5, backgroundColor: props.colorList[departure !== undefined ? departure.Availability__c : 'none'] }}>
                O
                {departure && departure.Availability__c === 'Full' &&
                    <span style={{ position: 'absolute', top: '-12px', left: '50%', transform: 'translateX(-50%)', color: props.colorList['Full'], fontWeight: 'bold', fontSize:'12px' }}>F</span>
                }
            </span>
        </div>
    );

    return element;
};

export default FlightSegmentView;
